import { defineStore } from 'pinia';
import actions from './actions.js';

function initState() {
    return {
        geoGraphic: {},
        countryConfig: {},
    };
}

export default (storeName) => defineStore(storeName, {
    state: initState,
    actions,
});
